'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDurationTotal = exports.getDistanceTotal = exports.formatActivities = exports.formatElevation = exports.formatDuration = exports.formatDistance = exports.formatMeasurementDomain = undefined;

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

var _duration = require('dayjs/plugin/duration');

var _duration2 = _interopRequireDefault(_duration);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _units = require('../units');

var units = _interopRequireWildcard(_units);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dayjs2.default.extend(_duration2.default);

var labels = {
  kilometers: { abbreviation: 'km', full: 'kilometers' },
  miles: { abbreviation: 'mi', full: 'miles' },
  feet: { abbreviation: 'ft', full: 'feet' },
  days: { abbreviation: 'd', full: 'days' },
  hours: { abbreviation: 'h', full: 'hours' },
  minutes: { abbreviation: 'm', full: 'minutes' },
  seconds: { abbreviation: 's', full: 'seconds' },
  meters: { abbreviation: 'm', full: 'meters' }
};

var formatMeasurementDomain = exports.formatMeasurementDomain = function formatMeasurementDomain(sortBy) {
  switch (sortBy) {
    case 'duration':
      return 'elapsed_time';
    case 'elevation':
      return 'elevation_gain';
    default:
      return sortBy;
  }
};

var formatDistance = exports.formatDistance = function formatDistance(distance, miles) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'abbreviation';

  if (miles) {
    return (0, _numbro2.default)(units.convertMetersToMiles(distance)).format('0,0[.]0') + (' ' + labels.miles[label]);
  } else {
    return (0, _numbro2.default)(units.convertMetersToKm(distance)).format('0,0[.]0') + (' ' + labels.kilometers[label]);
  }
};

var formatDuration = exports.formatDuration = function formatDuration(duration) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'abbreviation';

  if (duration >= 86400) {
    return '' + Math.floor(_dayjs2.default.duration(duration, 'seconds').asDays()) + labels.days[label] + ' ' + _dayjs2.default.duration(duration, 'seconds').hours() + labels.hours[label];
  } else if (duration >= 3600) {
    return '' + _dayjs2.default.duration(duration, 'seconds').hours() + labels.hours[label] + ' ' + _dayjs2.default.duration(duration, 'seconds').minutes() + labels.minutes[label];
  } else {
    return '' + _dayjs2.default.duration(duration, 'seconds').minutes() + labels.minutes[label] + ' ' + _dayjs2.default.duration(duration, 'seconds').seconds() + labels.seconds[label];
  }
};

var formatElevation = exports.formatElevation = function formatElevation(elevation, miles) {
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'abbreviation';

  if (miles) {
    return (0, _numbro2.default)(units.convertMetersToFeet(elevation)).format('0,0') + (' ' + labels.feet[label]);
  } else {
    return (0, _numbro2.default)(elevation).format('0,0') + (' ' + labels.meters[label]);
  }
};

var formatActivities = exports.formatActivities = function formatActivities(activities) {
  return (0, _numbro2.default)(activities).format('0,0');
};

var getDistanceTotal = exports.getDistanceTotal = function getDistanceTotal() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (page.fitness_activity_overview) {
    var overview = page.fitness_activity_overview;

    return Object.keys(overview).reduce(function (total, key) {
      return total + overview[key].distance_in_meters;
    }, 0);
  }

  return (0, _get2.default)(page, 'metrics.fitness.total_in_meters', 0);
};

var getDurationTotal = exports.getDurationTotal = function getDurationTotal() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (page.fitness_activity_overview) {
    var overview = page.fitness_activity_overview;

    return Object.keys(overview).reduce(function (total, key) {
      return total + overview[key].duration_in_seconds;
    }, 0);
  }

  return (0, _get2.default)(page, 'metrics.fitness.total_in_meters', 0);
};